import React, { useState, useRef, useEffect } from 'react';
import { List } from 'devextreme-react/list';
import { connect } from 'react-redux';
import axios from 'axios';
import data from '../assets/apiRoutes.json';
import notify from 'devextreme/ui/notify';

const ExpressionBaseQueryAvailableFields = ({ 
    expressionType = "evaluation",
    onFieldClick,
    height = "50vh",
    accessToken
}) => {
    const [selectedField, setSelectedField] = useState(null);
    const [availableFields, setAvailableFields] = useState([]);
    const [loading, setLoading] = useState(true);
    const availableFieldsListRef = useRef(null);

    useEffect(() => {
        loadAvailableFields();
    }, [expressionType, accessToken]);

    const loadAvailableFields = async () => {
        try {
            setLoading(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.EvaluationExpression.GetExpressionBaseQueryAvailableFields}?expressionType=${expressionType}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data && response.data.availableFields) {
                // Parse comma-separated string into array
                // Remove "AS alias" part and convert to uppercase
                // Example: "Customer.CustomerCLASSCODE AS CustomerCLASSCODE" -> "CUSTOMER.CUSTOMERCLASSCODE"
                const fields = response.data.availableFields
                    .split(',')
                    .map(field => {
                        // Remove "AS alias" part if present
                        let processedField = field.trim();
                        const asIndex = processedField.toUpperCase().indexOf(' AS ');
                        if (asIndex > -1) {
                            processedField = processedField.substring(0, asIndex).trim();
                        }
                        // Convert to uppercase
                        return processedField.toUpperCase();
                    })
                    .filter(field => field.length > 0)
                    .sort((a, b) => a.localeCompare(b)); // Sort alphabetically
                setAvailableFields(fields);
            } else {
                setAvailableFields([]);
            }
        } catch (error) {
            console.error('Error loading available fields:', error);
            notify('Failed to load available fields.', 'error', 3000);
            setAvailableFields([]);
        } finally {
            setLoading(false);
        }
    };

    const handleFieldClick = (fieldName) => {
        setSelectedField(fieldName);
        if (onFieldClick) {
            onFieldClick(fieldName);
        }
    };

    return (
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column', border: '1px solid #ddd', padding: '10px' }}>
            <label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Available Fields</label>
            {loading ? (
                <div style={{ height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    Loading...
                </div>
            ) : (
                <List
                    ref={availableFieldsListRef}
                    dataSource={availableFields}
                    height={height}
                    selectionMode="single"
                    searchEnabled={true}
                    onItemClick={(e) => handleFieldClick(e.itemData)}
                    selectedItems={selectedField ? [selectedField] : []}
                />
            )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        accessToken: state.oidc?.user?.access_token
    };
}

export default connect(mapStateToProps)(ExpressionBaseQueryAvailableFields);

